var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Input from 'components/Input.vue';
import { json } from 'overmind';
import { deburr, escapeRegExp } from 'lodash';
import { mixpanelTracking } from '@/services/mixpanel';
import { overmind, connect } from '@/overmind';
let TechnologyAndToolsPanel = class TechnologyAndToolsPanel extends Vue {
    constructor() {
        super(...arguments);
        this.filterOptions = this.filters.map(f => f.filterOptions);
        this.filteredFilters = json(this.filters);
        this.currentFilterIndex = 0;
        this.valueCheckbox = false;
        this.searchTerm = '';
        this.selectedWebSiteWorlds = [];
    }
    mounted() {
        // @ts-ignore
        this.selectedWebSiteWorlds = json(this.stateFilters.selectedWebSiteWords);
        this.searchTerm = this.fullTextTerm;
        if (this.fullTextTerm !== '') {
            this.filters.forEach(f => {
                this.onSearchFilters(f, this.fullTextTerm);
                this.currentFilterIndex += 1;
            });
            this.currentFilterIndex -= 1;
        }
    }
    onFullTextSearchChange(curr, old) {
        this.searchTerm = this.fullTextTerm;
        this.filters.forEach(f => {
            this.onSearchFilters(f, this.fullTextTerm);
            this.currentFilterIndex += 1;
        });
        this.currentFilterIndex -= 1;
    }
    async onFilterIndexChange(curr, old) {
        this.filterOptions[curr] =
            this.filters[this.currentFilterIndex].filterOptions;
    }
    onFiltersChange(curr, old) {
        if (curr) {
            // @ts-ignore
            this.filters = curr;
        }
    }
    setWebSiteWordsFilter({ value }, type) {
        overmind.actions.filters.setSelectedWebSiteWords({ value, type });
        overmind.actions.search.searches.buildPotentialResults();
    }
    selectedCount(filter) {
        if (filter.queryType === 'multiSelect') {
            return filter
                ? filter.filterOptions.filter(option => option.isSelected).length
                : 0;
        }
        if (filter.queryType === 'multiText') {
            return this.selectedWebSiteWorlds.length;
        }
        return 0;
    }
    onSearchFilters(filter, event) {
        if (event == null) {
            this.filteredFilters[this.currentFilterIndex].filterOptions = json(this.filterOptions[this.currentFilterIndex]);
            return;
        }
        let filterOptions = json(this.filterOptions[this.currentFilterIndex].filter(o => {
            const deburedTerm = escapeRegExp(deburr(this.searchTerm));
            if (o.tags) {
                const debured = deburr(Array.isArray(o.tags) ? o.tags.join(', ') : [o.tags].join(', '));
                const deburedMatch = debured.match(new RegExp(deburedTerm + '\\b', 'gi'));
                if (deburedMatch)
                    return deburedMatch;
            }
            const deburedLabel = o.label ? deburr(o.label) : undefined;
            return o.label && deburedLabel
                ? deburedLabel.match(new RegExp(deburedTerm, 'i'))
                : false;
        }));
        this.filteredFilters[this.currentFilterIndex].filterOptions =
            json(filterOptions);
    }
    onHideFilter(filterIndex) {
        if (this.fullTextTerm === '') {
            this.filteredFilters[filterIndex].filterOptions = json(this.filters[filterIndex].filterOptions);
        }
    }
    onShowFilter(filterIndex, filterTitle) {
        mixpanelTracking('filtros avançados: Expandiu o grupo de filtros: ' + filterTitle);
        this.currentFilterIndex = filterIndex;
        this.searchTerm = '';
    }
    setCheckbox(filterGroupId, filterId, filterIndex, filterOptionIndex, value, itemId) {
        const option = this.filteredFilters[filterIndex].filterOptions.find(o => o.value === itemId);
        if (option) {
            this.filteredFilters[this.currentFilterIndex].filterOptions[filterOptionIndex].isSelected = value;
        }
        this.$emit('setCheckbox', filterGroupId, filterId, filterIndex, filterOptionIndex, value, itemId);
    }
    beforeDestroy() {
        this.filteredFilters[this.currentFilterIndex].filterOptions = json(this.filterOptions[this.currentFilterIndex]);
    }
};
__decorate([
    Prop({ default: () => [] })
], TechnologyAndToolsPanel.prototype, "filters", void 0);
__decorate([
    Prop({ default: '' })
], TechnologyAndToolsPanel.prototype, "fullTextTerm", void 0);
__decorate([
    Prop({ default: 0 })
], TechnologyAndToolsPanel.prototype, "filterGroupId", void 0);
__decorate([
    Watch('fullTextTerm')
], TechnologyAndToolsPanel.prototype, "onFullTextSearchChange", null);
__decorate([
    Watch('currentFilterIndex')
], TechnologyAndToolsPanel.prototype, "onFilterIndexChange", null);
__decorate([
    Watch('filters')
], TechnologyAndToolsPanel.prototype, "onFiltersChange", null);
TechnologyAndToolsPanel = __decorate([
    Component(connect(({ state, actions }) => ({
        stateFilters: state.filters,
    }), {
        name: 'TechnologyAndToolsPanel',
        components: {
            Input,
        },
    }))
], TechnologyAndToolsPanel);
export default TechnologyAndToolsPanel;
